import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import BeforeAfterPage from './pages/BeforeAfterPage';
import BeforeAfterReorderPage from './pages/BeforeAfterReorderPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-slate-900 text-slate-100 selection:bg-amber-500 selection:text-slate-950 font-sans">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ydelser" element={<ServicesPage />} />
            <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />
            
            {/* Direct aliases from christiansmaskinservice.dk */}
            <Route path="/entreprenoer" element={<Navigate to="/ydelser/entreprenoer" replace />} />
            <Route path="/gravearbejde" element={<Navigate to="/ydelser/gravearbejde" replace />} />
            <Route path="/jordarbejde" element={<Navigate to="/ydelser/gravearbejde" replace />} />
            <Route path="/jord-gravearbejde" element={<Navigate to="/ydelser/gravearbejde" replace />} />
            <Route path="/nedbrydning" element={<Navigate to="/ydelser/nedbrydning" replace />} />
            <Route path="/belaegning" element={<Navigate to="/ydelser/belaegning" replace />} />
            <Route path="/belaegning-have" element={<Navigate to="/ydelser/belaegning-have" replace />} />
            <Route path="/belaegning-og-have" element={<Navigate to="/ydelser/belaegning-have" replace />} />
            <Route path="/anlaegsgartner" element={<Navigate to="/ydelser/anlaegsgartner" replace />} />
            <Route path="/anlaegsarbejde" element={<Navigate to="/ydelser/anlaegsgartner" replace />} />
            <Route path="/have" element={<Navigate to="/ydelser/belaegning-have" replace />} />
            <Route path="/haveservice" element={<Navigate to="/ydelser/belaegning-have" replace />} />
            <Route path="/total-rydning-af-haver" element={<Navigate to="/ydelser/total-rydning-af-haver" replace />} />
            <Route path="/total-rydning" element={<Navigate to="/ydelser/total-rydning-af-haver" replace />} />
            <Route path="/trampolin-nedgravning" element={<Navigate to="/ydelser/trampolin-nedgravning" replace />} />
            <Route path="/vognmand" element={<Navigate to="/ydelser/vognmand" replace />} />
            <Route path="/vognmandskoersel" element={<Navigate to="/ydelser/vognmand" replace />} />
            <Route path="/bortskaffelse" element={<Navigate to="/ydelser/bortskaffelse" replace />} />
            <Route path="/containerudlejning" element={<Navigate to="/ydelser/containerudlejning" replace />} />
            <Route path="/container-udlejning" element={<Navigate to="/ydelser/containerudlejning" replace />} />
            <Route path="/levering" element={<Navigate to="/ydelser/materialelevering" replace />} />
            <Route path="/materialelevering" element={<Navigate to="/ydelser/materialelevering" replace />} />
            <Route path="/materialer" element={<Navigate to="/ydelser/materialelevering" replace />} />
            
            <Route path="/om-os" element={<Navigate to="/om-cmsnord" replace />} />
            <Route path="/om-cmsnord" element={<AboutPage />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/galleri/foer-efter" element={<BeforeAfterPage />} />
            <Route path="/foer-efter" element={<BeforeAfterPage />} />
            
            {/* Skjult side til drag-and-drop sortering af før/efter opslag */}
            <Route path="/skjult-sortering" element={<BeforeAfterReorderPage />} />
            <Route path="/skjult/foer-efter-sortering" element={<BeforeAfterReorderPage />} />
            <Route path="/admin/foer-efter-sortering" element={<BeforeAfterReorderPage />} />

            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}
